import styles from './LoadingSpinner.module.scss';

const LoadingSpinner = () => {
    return (
        <div className={styles.loading_spinner}>
            <div className={styles.spinner} />
        </div>
    );
};

export default LoadingSpinner;
